import { toast } from "react-hot-toast";
import { Modal } from "ui";

import { useDeleteDeliveryZone } from "../../../apis";
import { DeleteDeliveryZoneModalProps } from "./DeleteDeliveryZoneModal.types";

import styles from "./DeleteDeliveryZoneModal.module.scss";

const DeleteDeliveryZoneModal = ({
  isOpen,
  id,
  onClose,
  onDeleteSuccess
}: DeleteDeliveryZoneModalProps) => {
  const deleteDeliveryZone = useDeleteDeliveryZone({
    onSuccess: () => {
      onClose();
      onDeleteSuccess();
      toast.success("Delivery Zone deleted successfully");
    }
  });

  return (
    <Modal
      type="delete"
      isOpen={isOpen}
      title="Delete Delivery Zone"
      isLoading={deleteDeliveryZone.isLoading}
      okText="Delete"
      onOk={() => deleteDeliveryZone.mutate(id)}
      contentClassName={styles.modal}
      onClose={onClose}
    >
      <p className={styles.modal_text}>
        Are you sure you want to delete this Delivery Zone?
      </p>
    </Modal>
  );
};

export default DeleteDeliveryZoneModal;
